import React, { useEffect } from "react";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Typography,
    Form,
    Col,
    Select,
    DatePicker,
    Divider,
    Tooltip,
    Descriptions,
    Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { SearchOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import { labelConfig, staticConfig } from "../../../../group.config";

const { Title } = Typography;

const DetailForm = (props) => {
    const {
        onSearch,
        currencyData,
        displayFields,
        groupInfo,
        showDetailsForm,
        handleSearchInTable,
        onFinish,
        form,
        onChangeProduct,
        productOptions,
        accountLinkingOptions,
        loanOfficerOptions,
        loanPurposeOptions,
        fundOptions
    } = props;
    const dateFormat = 'YYYY/MM/DD';

    useEffect(() => {
        defaultDate()
    }, [])

    const defaultDate = () => {
        form.setFieldsValue({
            submittedOnDate: dayjs(),
        })
    }

    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
        >
            <Row>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.productInfo}
                    </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.product}
                        name="productId"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.product),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.product,
                                "select"
                            )}
                            options={productOptions}
                            showSearch
                            onChange={onChangeProduct}
                        />
                    </Form.Item>
                </Col>

                {showDetailsForm && (
                    <>
                        <Row style={{ justifyContent: "space-between" }}>
                            <Divider orientation="left" orientationMargin="0">
                                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                    {labelConfig.generalInfo}
                                </Title>
                            </Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.loanOfficer}
                                    name="loanOfficerId"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.loanOfficer}`,
                                            "select"
                                        )}
                                        options={loanOfficerOptions}
                                        showSearch
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.loanPurpose}
                                    name="loanPurposeId"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.loanPurpose}`,
                                            "select"
                                        )}
                                        options={loanPurposeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.fund} name="fundId">
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.fund}`,
                                            "select"
                                        )}
                                        options={fundOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.submittedOn}
                                    name="submittedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.submittedOn),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.submittedOn}`,
                                            "select"
                                        )}
                                        style={{
                                            width: "100%",
                                            height: 35,
                                        }}
                                        disabledDate={disabledAfterCurrentDate}
                                        format={dateFormat}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.disbursementOn}
                                    name="expectedDisbursementDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.disbursementOn),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.disbursementOn}`,
                                            "select"
                                        )}
                                        style={{
                                            width: "100%",
                                            height: 35,
                                        }}
                                        disabledDate={disabledAfterCurrentDate}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                            </Col>

                            <Divider orientation="left" orientationMargin="0">
                                {labelConfig.meetingDetails}
                            </Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.startDate} name={"startDate"} >
                                    <Input
                                        className="of-bold-disable-input"
                                        disabled
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item label={labelConfig.repeatsOn} name={"repeatsOn"} >
                                    <Input
                                        className="of-bold-disable-input"
                                        disabled
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.syncRepayments}
                                    name="syncRepaymentsWithMeeting"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
                                        options={staticConfig.yesOrNoData}
                                        showSearch
                                    />{" "}
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.syncDisbursement}
                                    name="syncDisbursementWithMeeting"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
                                        options={staticConfig.yesOrNoData}
                                        showSearch
                                    />{" "}
                                </Form.Item>
                            </Col>

                            <Divider orientation="left" orientationMargin="0">
                                {labelConfig.savingsLinkage}
                            </Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.linkSavings}
                                    name="linkAccountId"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.linkSavings}`,
                                            "select"
                                        )}
                                        options={accountLinkingOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            {accountLinkingOptions.length !== 0 && (
                                <Col span={8} style={{ padding: "0px 8px" }}>
                                    <Form.Item
                                        label={
                                            <Tooltip title={labelConfig.createStandingInstruction}>
                                                {BOM.SubstringFormat(`${labelConfig.createStandingInstruction}`, 25)}
                                            </Tooltip>
                                        } name="createStandingInstructionAtDisbursement"
                                    >
                                        <Select
                                            filterOption={(input, option) =>
                                                (option?.label?.toLowerCase() ?? "").includes(
                                                    input?.toLowerCase()
                                                )
                                            }
                                            placeholder={BOM.handlePlaceholderMsg(
                                                `${labelConfig.option}`,
                                                "select"
                                            )}
                                            options={staticConfig.yesOrNoData}
                                            showSearch
                                        />{" "}
                                    </Form.Item>
                                </Col>

                            )}

                            <Col span={8} style={{ padding: "0px 8px" }}>
                            </Col>
                        </Row>
                    </>
                )}
            </Row>

        </Form>
    );
};

export default DetailForm;
